import React, { useState, useMemo } from 'react';
import { Stack } from '@mui/material';
import { colors, breakpoints, IconButton, CloseOutlineIcon } from '@web-for-marketing/react-ui';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { noticeBanners } from './publicNotice';

const classes = {
    bannerContainer: {
        position: 'relative',
        zIndex: 401,
        padding: '0.5rem 3.8rem',
        backgroundColor: colors.core.innovation,
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: '1.4rem 2.2rem',
        },
    },
    bannerText: {
        color: colors.core.snow,
        fontSize: '1.4rem',
        marginRight: '1rem',
        lineHeight: 1.5,
        '& a': {
            color: 'inherit',
            fontWeight: 'bold',
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    CloseOutlineIcon: {
        minWidth: '3rem',
        minHeight: '3rem',
        '& svg': {
            width: '1.4rem',
            height: '1.4rem',
        },
    },
} as const;

export function PublicNoticeBanner(): React.ReactElement | null {
    const [isVisible, setIsVisible] = useState<boolean>(true);
    const { fullUrl } = useStaticValues();

    const bannerContent = useMemo(() => {
        try {
            const cleanUrl = fullUrl.replace(/&amp;/g, '&');
            const url = new URL(cleanUrl);
            const noticeId = url.searchParams.get('notice');

            return noticeId ? noticeBanners.get(noticeId.toUpperCase()) || null : null;
        } catch (error) {
            console.warn('Failed to parse URL:', fullUrl, error);
            return null;
        }
    }, [fullUrl]);

    const handleClose = (): void => {
        setIsVisible(false);
    };

    if (!bannerContent || !isVisible) {
        return null;
    }

    return (
        <div css={classes.bannerContainer} role='status'>
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
                <span css={classes.bannerText} dangerouslySetInnerHTML={{ __html: bannerContent }} />
                <IconButton label='close' onClick={handleClose} size='micro' css={classes.CloseOutlineIcon}>
                    <CloseOutlineIcon />
                </IconButton>
            </Stack>
        </div>
    );
}
